<script context="module">
  import { Client, getLanguage } from '../utils/prismicHelpers';
  import { createRequest } from '../utils/request';

  export async function load({ session, error, status }) {
    const { API_BASE_URL, API_KEY, LANGUAGE } = session;
    let doc;

    doc = await Client().getSingle('integrations', { lang: getLanguage(LANGUAGE) });

    if (doc) {
      return {
        props: {
          doc,
          API_BASE_URL,
          API_KEY,
          LANGUAGE,
        },
      };
    } else {
      return {
        error,
        status,
      };
    }
  }
</script>

<script>
  import SliceZone from '../components/SliceZone.svelte';
  import ContactForm from '../components/ContactForm.svelte';
  import { _ } from 'svelte-i18n';
  import BookDemoWithButton from '../components/BookDemoWithButton.svelte';

  export let mainPageDoc, customerLogos, API_BASE_URL, API_KEY, LANGUAGE;

  const request = createRequest({
    apiBaseUrl: API_BASE_URL,
    apiKey: API_KEY,
    language: LANGUAGE,
  });

  export let doc;
</script>

<svelte:head>
  <title>{doc.data.meta_title}</title>
  <meta
    name="description"
    content={doc.data.meta_description}
  />
</svelte:head>

{#if doc}
  <SliceZone slices={doc.data.body} />
{/if}

<div class="contact-us">
  <h3>{$_('forDevelopers.getYourAPIKey.title')}</h3>
  <div class="contact-us__subheader">
    {$_('forDevelopers.getYourAPIKey.description')}
  </div>
  <ContactForm
    title={$_('forDevelopers.contactForm.title')}
    {LANGUAGE}
    {request}
  />
</div>

<style>
  .contact-us {
    padding: 50px 20px;
    background-position: center;
    background-size: cover;
  }
  .contact-us__subheader {
    width: 100%;
    text-align: center;
    line-height: 28px;
    margin-bottom: 33px;
    font-size: 18px;
  }
</style>
